// extracted by mini-css-extract-plugin
export var buttonsContainer = "ProRatedUpgrade_buttonsContainer__XCOTb";
export var contentWrapper = "ProRatedUpgrade_contentWrapper__6NvzB";
export var wrapper = "ProRatedUpgrade_wrapper__Q5ZXW";
export var wrapperBanner = "ProRatedUpgrade_wrapperBanner__-5Pch";